import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import "./feedbackv2.scss";
import { MdOutlineArrowBackIos } from "react-icons/md";
import {
  ClientFeedbackDetail,
  ResetFeedBack,
} from "../../../../actions/feedback/customerFeedBackAction";

const FeedbackForm = () => {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const loginCheck = localStorage.getItem("isLoggedIn");
  const navigate = useNavigate();

  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 767;

  useEffect(() => {
    if (loginCheck) {
      const clientEmail = localStorage.getItem("email");
      setEmail(clientEmail);
    }
  }, [loginCheck]);

  const feedbackStatus = useSelector((state) => state.ClientFeedbackReducer);
  useEffect(() => {
    if (feedbackStatus?.response) {
      setButtonLoading(false);
      setMessage("");
      toast.success("FeedBack added successfully!");
      dispatch(ResetFeedBack());
    }
  }, [feedbackStatus, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const userAgents = navigator.userAgent;
    const pathName = location.pathname;

    const data = {
      path: pathName,
      userAgent: userAgents,
      email: email,
      comment: message,
    };

    dispatch(ClientFeedbackDetail(data));
    setButtonLoading(true);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  return (
    <>
      {width > breakpoint ? (
        <div className="feedback-form-container h-100 d-flex align-items-center ">
          <div className="row w-100 justify-content-center text-center">
            <div className="col-md-7">
              <h5 className="arrow-text">Send Feedback</h5>
              <p>
                Tell Us What You Love About The App, Or What We Could Be Doing
                Better
              </p>
              {/* {loginCheck && <p>Logged in as: {email}</p>} */}
              <form onSubmit={handleSubmit}>
                <div className="form-groupfeedback text-start">
                  <h5 htmlFor="fomrf" className="" >Feedback</h5>
                  <textarea
                    rows="1"
                    id="fomrf"
                    placeholder="Enter Feedback"
                    className="form-controlfeedback"
                    value={message}
                    onChange={handleMessageChange}
                    autoFocus
                  ></textarea>
                </div>

                <div className="help-card d-none">
                  <div>
                    <img
                      src="https://fusionbucket.co.uk/My-account/feedbackstarimage.png"
                      alt="star-icon"
                      className="feedback-icon"
                    />
                  </div>
                  <div className="text-container">
                    <h3>Need Help With Your Order?</h3>
                    <p>Get Instant Help From Our Customer Support Team</p>
                  </div>
                </div>

                <div className="submit-feedback">
                  <button type="submit" className="submitbuttonnew">
                    {buttonLoading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Send Feedback"
                    )}
                  </button>
                </div>
                <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                />
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="feedback-form-container vh-100">
          {/* <h5 className='arrow-text '><MdOutlineArrowBackIos className='d-none arrowtop-icon' onClick={() => navigate('/myaccount')} /> Send Feedback</h5> */}
          <p>
            Tell Us What You Love About The App, Or What We Could Be Doing
            Better
          </p>
          <form onSubmit={handleSubmit}>
            <div className="form-groupfeedback">
              <textarea
                rows="1"
                placeholder="Enter Feedback"
                className="form-controlfeedback"
                value={message}
                onChange={handleMessageChange}
                autoFocus
              ></textarea>
            </div>
            <div className="help-card">
              <div>
                <img
                  src="https://fusionbucket.co.uk/My-account/feedbackstarimage.png"
                  alt="star-icon"
                  className="feedback-icon"
                />
              </div>
              <div className="text-container">
                <h3>Need Help With Your Order?</h3>
                <p>Get Instant Help From Our Customer Support Team</p>
              </div>
            </div>
            <div className="submit-feedback">
              <button type="submit" className="submitbuttonnew">
                {buttonLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Send Feedback"
                )}
              </button>
            </div>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
            />
          </form>
        </div>
      )}
    </>
  );
};

export default FeedbackForm;
